import React from 'react';
import { Plus } from 'lucide-react';
import { Product } from '../types';
// Indian Rupee formatting helper
const formatINR = (amount: number): string => {
  return `₹${Math.round(amount).toLocaleString('en-IN')}`;
};
interface ProductCardProps {
  product: Product;
  onAdd: () => void;
}
export function ProductCard({
  product,
  onAdd
}: ProductCardProps) {
  return <div className="bg-white rounded-2xl p-3 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-142">
      <div className="aspect-square rounded-xl bg-gray-100 mb-3 overflow-hidden relative group" data-id="element-143">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-144" />
        <button onClick={e => {
        e.stopPropagation();
        onAdd();
      }} className="absolute bottom-2 right-2 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center text-purple-600 active:scale-90 transition-transform" data-id="element-145">
          <Plus size={18} strokeWidth={3} data-id="element-146" />
        </button>
      </div>
      <div className="flex-1 flex flex-col" data-id="element-147">
        <h3 className="font-bold text-gray-900 text-sm leading-tight mb-1" data-id="element-148">
          {product.name}
        </h3>
        <p className="text-xs text-gray-500 line-clamp-2 mb-2 flex-1" data-id="element-149">
          {product.description}
        </p>
        <div className="font-bold text-gray-900" data-id="element-150">
          {formatINR(product.price)}
        </div>
      </div>
    </div>;
}